module.exports = __webpack_public_path__ + "fonts/DXI1ORHCpsQm3Vp6mXoaTfgrLsWo7Jk1KvZser0olKY.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/DXI1ORHCpsQm3Vp6mXoaTfgrLsWo7Jk1KvZser0olKY.woff2
// module id = 375
// module chunks = 0